import { ActionReducerMap } from '@ngrx/store';
import { SessionState } from '@store/session/session.state';
import { SessionStateReducer } from '@store/session/session.reducer';
import { AppState } from '@store/app/app.state';
import { AppStateReducer } from '@store/app/app.reducer';

export interface MainState {
  sessionState: SessionState;
  appState: AppState;
}

export const MAIN_REDUCER: ActionReducerMap<MainState> = {
  sessionState: SessionStateReducer,
  appState: AppStateReducer,
}